// extracted by mini-css-extract-plugin
export default {"layout":"OptionCardList_layout__gmZ31"};